// Module
var code = "<div angucomplete-alt id=\"clientSearch\" placeholder=\"Search Client\" pause=\"500\" selected-object=\"vm.onSelectClient\" remote-api-handler=\"vm.clientSearchApi\" title-field=\"PreferedName\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\" initial-value=\"vm.initialValue\"></div> ";
// Exports
module.exports = code;